export default __webpack_public_path__ + "static/media/img1.cf02b7ae.jpeg";